import { APP_AUTH_RESULT } from './globalState';
import { getOrThrow, has } from 'quartz/globalState/api';
const getAppAuthResult = () => {
  if (!has(APP_AUTH_RESULT)) {
    throw new Error('App auth not initialized');
  }
  return getOrThrow(APP_AUTH_RESULT);
};
/**
 * Gets the current user's userInfo/login-verify response
 *
 * @example
 * ```ts
 * const userInfo = getAuth();
 *
 * const { email } = userInfo.user;
 * ```
 */
export const getAuth = () => getAppAuthResult().auth;

/**
 * Gets the current user's scopes as a Set<string>
 *
 * @example
 * ```ts
 * const canRead = getScopes().has('scope:read');
 * ```
 */
export const getScopes = () => getAppAuthResult().scopes;

/**
 * Gets the current user's gates as a set
 *
 * Returns both v2 and v3 gates.
 *
 * Will append or omit extra gates via the ?gated and ?ungated query params.
 *
 * @example
 * ```ts
 * const myGate = gate('my-gate');
 *
 * const hasMyGate = getGates().has(myGate);
 * ```
 */
export const getGates = () => getAppAuthResult().gates;